import { Grid } from '@material-ui/core';
import React from 'react';
import SearchBox from '../../../components/table/SearchBox';

const Layout = ({ title = 'Title', searchQuery, onChange, children, className }) => {
    return (
        <div>
            <div style={{ textAlign: 'center' }}>
                <h1 style={{ paddingLeft: 8, color: 'grey' }}>{title}</h1>
            </div>
            <Grid container>
                <SearchBox searchQuery={searchQuery} onChange={onChange} placeholder="Search..." />
                <Grid item xs={10} />
            </Grid>
            <hr />
            <div>{children}</div>
        </div>
    );
};

export default Layout;
